import grid from './grid.svg';
import list from './list.svg';

const icons = {grid, list};
export default icons;

